import { FC, createRef, useCallback, useEffect, useState } from "react";

import IRiepilogoProps from "components/Riepilogo/IRiepilogoProps";

import { Alert, Collapse } from "antd";
import { HR } from "core/interfaces/components/index";

import "./Riepilogo.css";
import moment from "moment";
import { FaAngleDown, FaInfoCircle } from "react-icons/fa";
import { IPreventivoDetailDataSlice } from "core/redux/features/dataForm/dataFormSliceInterfaces";
import { Enhanced } from "utils/ReactUtils";
import CustomTranslation from "components/CustomTranslation/CustomTranslation";
import { PrestazioneRepository } from "core/data/index";
import { INumericArrayRequest } from "core/interfaces/data/Base";
import CustomShelf from "components/CustomShelf/CustomShelf";
import { IDescrizioneAttivita } from "core/interfaces/data/IPrestazioneRequest";

const Riepilogo: FC<IRiepilogoProps> = ({ nuovaPrenotazione, t, dataForm, i18n }) => {
	const { Panel } = Collapse;

	const descrizioneRef: any = createRef();
	const predescrizioneRef: any = createRef();

	const getCanShowData = () => {
		if (dataForm.orario && dataForm.tariffa && dataForm.prestazione && dataForm.professionista) return true;
		else if (dataForm.resultPrenotazione?.PreventivoDetail && dataForm.resultPrenotazione?.PreventivoDetail.length > 0) return true;

		return false;
	};

	const getAttivita = () => {
		if (dataForm.prestazione) return dataForm.prestazione?.Attivita;
		else if (dataForm.resultPrenotazione?.PreventivoDetail) {
			return dataForm.resultPrenotazione?.PreventivoDetail.map((value: IPreventivoDetailDataSlice) => {
				return value.Attivita;
			}).join(",");
		}
	};

	const getOraInizio = () => {
		if (dataForm.orario) return dataForm.orario.Da;
		else if (dataForm.resultPrenotazione?.PreventivoDetail) {
			return dataForm.resultPrenotazione?.PreventivoDetail.map((value: IPreventivoDetailDataSlice) => {
				return value.Da;
			}).join(",");
		}
		return "";
	};

	const getOraFine = () => {
		if (dataForm.orario) return dataForm.orario.A;
		else if (dataForm.resultPrenotazione?.PreventivoDetail) {
			return dataForm.resultPrenotazione?.PreventivoDetail.map((value: IPreventivoDetailDataSlice) => {
				return value.A;
			}).join(",");
		}
		return "";
	};

	const canShowProfessionista = () => {
		if (dataForm.professionista) {
			return !dataForm.professionista.Generico;
		} else if (
			dataForm.resultPrenotazione?.PreventivoDetail &&
			dataForm.resultPrenotazione?.PreventivoDetail.filter((dett) => {
				return !dett.OperatoreGenerico;
			}).length > 0
		) {
			return dataForm.resultPrenotazione?.PreventivoDetail.filter((dett) => {
				return !dett.OperatoreGenerico;
			})
				.map((value: IPreventivoDetailDataSlice) => {
					return value.DsOperatore;
				})
				.join(",");
		}
		return false;
	};

	const getProfessionista = () => {
		if (dataForm.professionista) {
			return dataForm.professionista.DsOperatore;
		} else if (dataForm.resultPrenotazione?.PreventivoDetail) {
			return dataForm.resultPrenotazione?.PreventivoDetail.filter((dett) => {
				return !dett.OperatoreGenerico;
			})
				.map((value: IPreventivoDetailDataSlice) => {
					return value.DsOperatore;
				})
				.join(",");
		}
		return "";
	};

	const getDestinatario = () => {
		var res: string | undefined;
		if (dataForm.destinatarioAssistenza) res = `${dataForm.destinatarioAssistenza.Cognome} ${dataForm.destinatarioAssistenza.Nome} `;
		else if (dataForm.resultPrenotazione?.ResPrenotazione) res = `${dataForm.resultPrenotazione?.ResPrenotazione.DestPrestazione} `;
		return res;
	};

	const getLuogo = () => {
		var resIndirizzo: string | undefined;
		if (dataForm.area && dataForm.area.LuogoErogazione) {
			let luogo = dataForm.area.LuogoErogazione;
			var via = luogo.Via;
			if (luogo.Civico !== undefined && (luogo.Civico ?? "") !== "") {
				via = via + " " + luogo.Civico;
			}

			resIndirizzo = `<span>${luogo.Via ? via + "," : ""} </span><span>  ${luogo.CAP ?? ""}, ${luogo.Comune ?? ""} ${
				luogo.Provincia ? "(" + luogo.Provincia + ")" : ""
			} </span> `;
		}
		return resIndirizzo;
	};

	const [descrizione, setDescrizione] = useState<string>("");
	const [descrizioneVisibile, setDescrizioneVisibile] = useState<boolean>(false);
	const recuperaDescrizione = useCallback(
		async (igu: number) => {
			const request: INumericArrayRequest = {
				culture: i18n.language,
				Values: [igu],
			};
			const descrizioni = await PrestazioneRepository.getDescrizionePrestazioni(request);
			if (descrizioni !== undefined) {
				const ds = descrizioni.find((el: IDescrizioneAttivita) => {
					return el.IguAttivita === igu;
				});
				if (ds !== undefined) setDescrizione(ds.DettagliAttivita);
				else setDescrizione("");
			} else setDescrizione("");
		},
		[i18n.language]
	);
	useEffect(() => {
		if (dataForm.prestazione?.IguAttivita) {
			recuperaDescrizione(dataForm.prestazione?.IguAttivita);
		} else if (dataForm?.resultPrenotazione?.PreventivoDetail !== undefined && dataForm?.resultPrenotazione?.PreventivoDetail.length > 0) {
			recuperaDescrizione(dataForm?.resultPrenotazione?.PreventivoDetail[0].IguAttivita);
		}
	}, [dataForm.prestazione?.IguAttivita, dataForm?.resultPrenotazione?.PreventivoDetail, recuperaDescrizione]);

	const mostraDescrizioneAttivita = (value: boolean) => {
		if (value && descrizione === "" && dataForm.prestazione?.IguAttivita) recuperaDescrizione(dataForm.prestazione?.IguAttivita);
		setDescrizioneVisibile(value);
	};
	useEffect(() => {
		if (descrizione !== "") {
			try{
				if (descrizioneVisibile && descrizioneRef.current !== undefined) descrizioneRef.current.focus();
				else if (!descrizioneVisibile && predescrizioneRef.current !== undefined) predescrizioneRef.current.focus();
			}catch(err){}
		}
	}, [descrizione, descrizioneRef, descrizioneVisibile, predescrizioneRef]);

	useEffect(() => {
		if (dataForm.prestazione?.IguAttivita) recuperaDescrizione(dataForm.prestazione?.IguAttivita);
	}, [dataForm.prestazione?.IguAttivita, recuperaDescrizione]);

	return (
		<Collapse
			expandIconPosition="end"
			expandIcon={({ isActive }) => <FaAngleDown className={`${isActive ? "expanded" : "collapsed"}`} />}
			className="pannello-riepilogo"
		>
			<Panel
				header={
					<>
						{nuovaPrenotazione && t("riepilogo.title")}
						<CustomTranslation
							t={t}
							i18Key="riepilogo.titlePrestazione"
							type="custom"
							customComponents={{
								br: <br />,
								span: <span />,
							}}
							customValues={{Attivita:getAttivita()}}
						/>
					</>
				}
				className="pannel-title"
				key="1"
				forceRender
			>
				<div id="riepilogo">
					{
						<>
							{" "}
							{getDestinatario() && (
								<>
									<div className="recapText item item-left text">
										<span className="subtitle">{t("riepilogo.text.assistito")}</span>
										<span className="dateContainer">
											<span>{getDestinatario()}</span>
										</span>
									</div>
									<HR></HR>
								</>
							)}
							{getCanShowData() ? (
								<>
									<div className="recapText item item-left text">
										<span className="subtitle">{t("riepilogo.text.dataOraPrenotazione")}</span>

										<span className="dateContainer">
											<CustomTranslation
												t={t}
												i18Key="riepilogo.text.dataOraPrenotazioneFormat"
												type="custom"
												customComponents={{
													br: <br />,
													span: <span />,
													nbsp: <>&nbsp;</>,
												}}
												customValues={{
													Giorno:getOraInizio().toDateWS().toTextWeekday(true),
													Data: moment(getOraInizio()).format("L"),
													OraInizio:moment(getOraInizio()).format("LT"),
													OraFine:moment(getOraFine()).format("LT")
												}}
											/>
										</span>
									</div>

									<HR></HR>

									{/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
									<div className="recapText item item-left text" tabIndex={0} ref={predescrizioneRef}>
										<span className="subtitle">{t("riepilogo.text.prestazione")}</span>
										<span className="dateContainer">
											<span>{getAttivita()}</span>
											{/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
											<FaInfoCircle
												tabIndex={0}
												className={`icona-info-attivita ${descrizione!==""?"esistente":""}`}
												role="button"
												aria-label="show description"
												onClick={() => {
													mostraDescrizioneAttivita(true);
												}}
												onKeyUp={(ev: any) => {
													if (ev.code.toLowerCase() === "enter") mostraDescrizioneAttivita(true);
												}}
											/>

											<CustomShelf
												open={descrizioneVisibile}
												onClose={() => {
													setDescrizioneVisibile(false);
												}}
											>
												{/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
												<div className="shelf-descrizione-attivita" tabIndex={0} ref={descrizioneRef}>
													<h2>{t("riepilogo.text.descrizione")}</h2>
													{descrizione ? (
														<p className="testo-descrizione-attivita" dangerouslySetInnerHTML={{ __html: descrizione }}></p>
													) : (
														<p>{t("riepilogo.text.descrizione-assente")}</p>
													)}
												</div>
											</CustomShelf>
										</span>
									</div>
									{canShowProfessionista() && (
										<>
											<HR></HR>
											<div className="recapText item item-left text">
												<span className="subtitle">{t("riepilogo.text.operatore")}</span>
												<span className="dateContainer">
													<span>{getProfessionista()}</span>
												</span>
											</div>
										</>
									)}

									{getLuogo() && (
										<>
											<HR></HR>
											<div className="recapText item item-left text">
												<span className="subtitle">{t("riepilogo.text.luogo")}</span>
												<span className="dateContainer">
													<CustomTranslation
														t={t}
														i18Key="luogo"
														type="custom"
														customComponents={{
															span: <span />,
														}}
														customValues={{Luogo:getLuogo() ?? ""}}
													/>
												</span>
											</div>
										</>
									)}
									<HR></HR>
									<br />

									{dataForm.tariffa && (
										<div className="total">
											<div className="text item ">
												<span>{t("riepilogo.text.subTitle")}</span>
											</div>

											<div className="total-box item">
												<span>
													{dataForm.tariffa.ImportoTariffaConIva !== undefined &&
														dataForm.tariffa.ImportoTariffaConIva.toLocaleString(
															undefined, // leave undefined to use the visitor's browser
															// locale or a string like 'en-US' to override it.
															{ style: "currency", currency: "EUR" }
														)}
												</span>
											</div>
										</div>
									)}
									<div className="footer item no-margin-bottom">
										<span>{t("riepilogo.text.istruzioni")}</span>
									</div>
								</>
							) : (
								<Alert message={t("errorMessages.base")} type="error" showIcon banner />
							)}
						</>
					}
				</div>
			</Panel>
		</Collapse>
	);
};

export default Enhanced(Riepilogo, { componentNamespace: "Riepilogo" });
